import { DataBean } from "../DataBean";

export class FixedAssetStateConstants extends DataBean {


    public async getFixedAssetStateConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFixedAssetStateConstants_Number", [id]);
    }
   

    

 
}